module.exports = __webpack_public_path__ + "static/media/bapb-logo.809b57cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bapb-logo.png
// module id = 315
// module chunks = 0